import { initializeApp } from 'firebase/app';
import { 
  initializeFirestore, 
  persistentLocalCache,
  persistentMultipleTabManager,
  connectFirestoreEmulator 
} from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyCMJRBhBuPUbyTofrU3VonqqE2J-IYWtqI",
    authDomain: "trhon-checklists.firebaseapp.com",
    projectId: "trhon-checklists",
    storageBucket: "trhon-checklists.firebasestorage.app",
    messagingSenderId: "161834948957",
    appId: "1:161834948957:web:0644ffa4732d78a47370b4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with persistence enabled
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

// Initialize services
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'us-central1'); // Specify region

// Connect to emulators in development
if (process.env.NODE_ENV === 'development') {
  connectFirestoreEmulator(db, 'localhost', 8082);
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export { db, auth, storage, functions };
